import React, { useEffect, useRef } from "react";

import ReceivedMessageCell from "./ReceivedMessageCell";
import SentMessageCell from "./SentMessageCell";

const Conversation = ({ conversationHistory, selectedUser }) => {
  const lastMessageRef = useRef(null);

  const user_uuid = localStorage.getItem("user_uuid");

  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  }, [conversationHistory]);

  return (
    <div className="gx-chat-main-content">
      {conversationHistory.map((conversation, index) => (
        <div
          key={index}
          // onClick={() => console.log("conversation", conversation)}
          ref={index === conversationHistory.length - 1 ? lastMessageRef : null}
        >
          {conversation.sender === selectedUser.receiver_uuid ||
          conversation.sender_type === "receiver" ||
          !conversation?.from?.includes(user_uuid) ? (
            <ReceivedMessageCell
              conversation={conversation}
              user={selectedUser}
            />
          ) : (
            <SentMessageCell conversation={conversation} user={selectedUser} />
          )}
        </div>
      ))}
    </div>
  );
};

export default Conversation;